import { useExternalMedia } from "../../../hooks/useExternalMedia";

export const EratekDigitalSolutions = () => {
  const {
    hrTech,
    appManagement,
    webDev,
    techSupport,
    projectManagement,
    digitalSolutions,
  } = useExternalMedia();

  const eratekHelpHighlights = [
    {
      id: 0,
      image: hrTech,
      service: "HR Technology/HCM",
      summary:
        "We implement cutting-edge HR technologies to attract, develop, and retain top talent, fostering a high-performance culture and enabling data-driven decision-making for your organisation.",
    },
    {
      id: 1,
      image: appManagement,
      service: "Application Management",
      summary:
        "We streamline operations with tailored application solutions. Our team develops, deploys, and maintains custom applications addressing your unique business challenges. We optimize workflows and enhance user experience, ensuring your applications drive efficiency and growth.",
    },
    {
      id: 2,
      image: webDev,
      service: "Web Development & Branding",
      summary:
        "Elevate your online presence with expert web development and branding. We create responsive, visually stunning websites that capture your brand essence. Our solutions combine cutting-edge design with powerful functionality, helping your business stand out digitally.",
    },
    {
      id: 3,
      image: techSupport,
      service: "Technical Support",
      summary:
        "Ensure seamless operations with our robust technical support. We provide swift IT issue resolution, proactive maintenance, and user assistance. Our team keeps your technology infrastructure running smoothly, minimizing downtime and maximizing business productivity.",
    },
    {
      id: 4,
      image: projectManagement,
      service: "Project Management",
      summary:
        "Achieve your business goals with skilled project management. We oversee complex initiatives from start to finish, ensuring timely delivery within budget. Our methodologies optimize resources, mitigate risks, and drive successful outcomes for your critical projects.",
    },
    {
      id: 5,
      image: digitalSolutions,
      service: "We Provide Digital Solutions",
      summary:
        "Eratek offers comprehensive digital solutions to propel your business forward. From custom software to innovative marketing strategies, we leverage cutting-edge technologies and best practices. Our tailored approach helps you navigate challenges and achieve sustainable growth in the evolving digital landscape.",
    },
  ];

  return { eratekHelpHighlights };
};
